import { Button, Form, Grid, Input, Toast } from 'antd-mobile';
import { useI18n } from 'i18n/useI18n';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserApi, { UserPolyInfoDT } from 'services/apis/sys/user-api';
import { removeItem } from 'utils/localStorageUtil';
import regUtil from 'utils/regUtil';
import { scrollTop } from 'utils/screenUtil';

const UserSetting = (props: {
  userInfo: UserPolyInfoDT;
  onBindEmail: (emial: string) => void;
  onBindPhone: (phone: string) => void;
}) => {
  const { t } = useI18n();
  const passwordTip = t('setting.index.028478-2') + t('setting.index.028478-1');
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const onFinish = (value: any | { password: string; password3: string }) => {
    const fetch = async () => {
      const result = await UserApi.alterPwd({
        userId: props.userInfo.asUser.uuid as string,
        oldPwd: value.password,
        newPwd: value.password3,
      });
      if (result.code === 0 && result.successful) {
        Toast.show(t('setting.index.863806-0'));
        form.resetFields();
        removeItem('user');
        removeItem('grpup');
        setInterval(() => {
          navigate('/login');
        }, 3000);
      } else {
        Toast.show(t('setting.index.863806-1'));
      }
    };
    fetch();
  };
  useEffect(() => {
    // scrollTop();
  }, []);
  return (
    <>
      {props.userInfo != null && props.userInfo !== undefined && (
        <>
          {/* 上传头像 */}
          {/* <div>
            <p style={{ textAlign: "left", fontSize: 14 }}>修改头像</p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
              className=" mb-2"
            >
              <Grid columns={5}>
                <Grid.Item span={1} style={{ display: "flex", alignItems: "center" }}>
                  <RoundImg width={80} src={img.avatar} />
                </Grid.Item>
                <Grid.Item span={4} className=" ml-5">
                  <p style={{ textAlign: "left", fontSize: 11, color: "#666" }}>
                    在这里大家都是“有头有脸”的朋友，上传头像让大家更快认识你可以上传jpg,gif动图,png格式的图片，且文件小于2M
                  </p>
                  <div className=" flex justify-center items-center mt-1">
                    <div
                      style={{
                        background: "#f66",
                        color: "#fff",
                        borderRadius: 8,
                        padding: "5px 15px",
                      }}
                      className=" w-24 flex flex-col justify-center items-center"
                    >
                      <TiUpload
                        style={{
                          fontWeight: "bolder",
                          marginRight: 5,
                          fontSize: 16,
                        }}
                      />
                      <span style={{ fontSize: 14 }}>上传头像</span>
                    </div>
                  </div>
                </Grid.Item>
              </Grid>
            </div>
          </div> */}
          <div>
            <p className=" m-2 ml-0 text-[16px]">{'修改绑定'}</p>
            <Form
              form={form}
              className=" rounded-xl shadow-md overflow-hidden"
            >
              <Grid columns={5}>
                <Grid.Item span={4}>
                  <Form.Item
                    key="email"
                    name="email"
                  >
                    <Input
                      placeholder={props.userInfo.asUserDetail?.userEmail || t('setting.index.863806-10')}
                      style={{ height: '10px' }}
                    />
                  </Form.Item>
                </Grid.Item>
                <Grid.Item style={{ display: 'flex', alignItems: 'center' }}>
                  <Button
                    style={{
                      width: '100%',
                      background: '#f66',
                      color: '#fff',
                      borderRadius: 8,
                      fontSize: 14,
                      padding: 8,
                      marginLeft: 5,
                      marginRight: 5,
                    }}
                    onClick={() => {
                      const email = form.getFieldValue('email');
                      if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email)) {
                        Toast.show(t('setting.index.863806-11'));
                        return;
                      }
                      const fetch = async () => {
                        const result = await UserApi.alterEmail({
                          userId: props.userInfo.asUser.uuid as string,
                          email: form.getFieldValue('email') as string,
                        });
                        if (result.code === 0 && result.successful) {
                          Toast.show(t('setting.index.863806-12'));
                          props.onBindEmail(email);
                        } else {
                          Toast.show(t('setting.index.863806-13'));
                        }
                      };
                      fetch();
                    }}
                  >
                    {props.userInfo.asUserDetail?.userEmail != null
                      ? t('setting.index.863806-14')
                      : t('setting.index.863806-15')}
                  </Button>
                </Grid.Item>
              </Grid>
              <Grid columns={5}>
                <Grid.Item span={4}>
                  <Form.Item
                    key="phone"
                    name="phone"
                  >
                    <Input
                      placeholder={props.userInfo.asUserDetail?.userPhone || t('setting.index.863806-16')}
                      style={{ height: '10px' }}
                      // defaultValue={props.userInfo.userDetail?.userPhone}
                    />
                  </Form.Item>
                </Grid.Item>
                <Grid.Item style={{ display: 'flex', alignItems: 'center' }}>
                  <Button
                    style={{
                      width: '100%',
                      background: '#f66',
                      color: '#fff',
                      borderRadius: 8,
                      fontSize: 14,
                      padding: 8,
                      marginLeft: 5,
                      marginRight: 5,
                    }}
                    onClick={() => {
                      const phone = form.getFieldValue('phone');
                      if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(phone)) {
                        Toast.show(t('setting.index.863806-17'));
                        return;
                      }
                      const fetch = async () => {
                        const result = await UserApi.alterPhone({
                          userId: props.userInfo.asUser.uuid as string,
                          phone: form.getFieldValue('phone') as string,
                        });
                        if (result.code === 0 && result.successful) {
                          Toast.show(t('setting.index.863806-12'));
                          props.onBindPhone(phone);
                        } else {
                          Toast.show(t('setting.index.863806-13'));
                        }
                      };
                      fetch();
                    }}
                  >
                    {props.userInfo.asUserDetail?.userPhone != null
                      ? t('setting.index.863806-14')
                      : t('setting.index.863806-15')}
                  </Button>
                </Grid.Item>
              </Grid>
              <p className=" text-xs mx-4 my-2 text-gray-500">{'*用于找回密码, 请确保信息正确'}</p>
            </Form>
          </div>
          <div>
            <p className=" m-2 ml-0 mt-4 text-[16px]">{'修改密码'}</p>
            <Form
              form={form}
              onFinish={onFinish}
              className=" rounded-xl shadow-md overflow-hidden"
            >
              <Form.Item
                key="password"
                name="password"
                style={{ fontSize: 10 }}
                rules={[
                  { required: true, message: t('setting.index.863806-5') },
                  {
                    pattern: regUtil.passwordRegexp,
                    message: passwordTip,
                  },
                ]}
              >
                <Input
                  placeholder={t('setting.index.863806-5')}
                  style={{ fontSize: 10 }}
                />
              </Form.Item>
              <Form.Item
                key="password2"
                name="password2"
                rules={[
                  { required: true, message: t('setting.index.863806-6') },
                  {
                    pattern: regUtil.passwordRegexp,
                    message: passwordTip,
                  },
                  {
                    validator: (rule, value, callback) => {
                      const password = form.getFieldValue('password');
                      if (password && value && password === value) {
                        return callback(t('setting.index.863806-7'));
                      }
                      return callback();
                    },
                  },
                ]}
              >
                <Input
                  placeholder={t('setting.index.863806-6')}
                  style={{ height: '10px' }}
                />
              </Form.Item>
              <Form.Item
                key="password3"
                name="password3"
                rules={[
                  { required: true, message: t('setting.index.863806-8') },
                  {
                    pattern: regUtil.passwordRegexp,
                    message: passwordTip,
                  },
                  {
                    validator: (rule, value, callback) => {
                      const password2 = form.getFieldValue('password2');
                      if (password2 && value && password2 !== value) {
                        return callback(t('setting.index.863806-9'));
                      }
                      return callback();
                    },
                  },
                ]}
              >
                <Input
                  placeholder={t('setting.index.863806-8')}
                  style={{ height: '10px' }}
                />
              </Form.Item>
              {/* <p className=" text-xs mx-4 my-2 text-gray-500">{"*不修改请留空"}</p> */}
              <div className=" flex justify-center items-center p-2">
                <Button
                  type="submit"
                  style={{
                    background: '#f66',
                    color: '#fff',
                    borderRadius: 8,
                    fontSize: 14,
                    padding: '10px 0px',
                  }}
                  className=" w-36 "
                >
                  {t('setting.index.863806-3')}
                </Button>
              </div>
            </Form>
          </div>
        </>
      )}
    </>
  );
};

export default UserSetting;
